import { LogoImgAttraction } from '../../../Files/LogoImgAttraction.js';
import { LogoImgOrigin } from '../../../Files/LogoImgOrigin.js';
import { LogoImgDefault } from '../../../Files/LogoImgDefault.js';

export const CarrouselTotal = (label, datas) => {
    let total = 0;
    switch (label) {
        default:
        case 'character':
            total = LogoImgDefault('img').length;
            break;
        case 'attraction':
        case 'archive':
            if (datas[0]) {
                total = LogoImgAttraction('img', datas[0].cslug, datas[0].aslug).length;
            }
            break;
        case 'origin':
            if (datas[0]) {
                total = LogoImgOrigin('img', datas[0].otname, datas[0].oslug).length;
            }
            break;
    }
    return total;
}